import { render, staticRenderFns } from "./saas_account_deduction.vue?vue&type=template&id=2c1e0806&scoped=true"
import script from "./saas_account_deduction.vue?vue&type=script&lang=js"
export * from "./saas_account_deduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1e0806",
  null
  
)

export default component.exports